import { StatusColor } from '../../../common/constants/color.constants'

export enum MilestoneType {
  Milestone = 'Milestone',
  Activity = 'Activity',
}

export enum MilestoneStatus {
  New = 'new',
  InProgress = 'in-progress',
  Paused = 'paused',
  ReadyToCheck = 'readyToCheck',
  Checking = 'checking',
  Completed = 'completed',
  CheckFailed = 'checkFailed',
  HasProblem = 'hasProblem',
}

export enum MilestoneChecklistStatus {
  New = 'new',
  InProgress = 'in-progress',
  Paused = 'paused',
  ReadyToCheck = 'readyToCheck',
  Checking = 'checking',
  Completed = 'completed',
  CheckFailed = 'checkFailed',
  HasProblem = 'hasProblem',
}

export const ChecklistStatusMap = {
  [MilestoneChecklistStatus.New]: StatusColor.New,
  [MilestoneChecklistStatus.InProgress]: StatusColor.InProgress,
  [MilestoneChecklistStatus.Paused]: StatusColor.Paused,
  [MilestoneChecklistStatus.ReadyToCheck]: StatusColor.ReadyToCheck,
  [MilestoneChecklistStatus.Checking]: StatusColor.Checking,
  [MilestoneChecklistStatus.Completed]: StatusColor.Completed,
  [MilestoneChecklistStatus.CheckFailed]: StatusColor.CheckFailed,
  [MilestoneChecklistStatus.HasProblem]: StatusColor.HasProblem,
}
